import React, { useEffect, useState } from 'react';
import ReportHeaderComponent from '../components/reportHeaderComponent';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import reportPdfIcon from '../../../../assets/image/report-pdf-icon.svg';
import xlsIcon from '../../../../assets/image/xls-icon.svg';
import csvIcon from '../../../../assets/image/csv-icon.svg';
import PageLoader from '../../../../component/PageLoader';
import Table from '../../../../component/table/Table';
import ReportScheduledDrawer from '../components/reportScheduledDrawer';
import { exportExcelScheduledReport, getScheduledReport } from '../../../../services/reports';
import { capitalizeWords, formatAMPMDate } from '../../../../utils/constant';
import ScheduleReportModal from '../components/scheduleReportModal';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';

export default function ScheduledReports({ activeTab, setIsCollapse, isCollapse }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [sortDirection, setSortDirection] = useState({});
	const [scheduledId, setScheduledId] = useState(null);
	const [loader, setLoader] = useState(false);
	const [isExportExcelLoader, setIsExportExcelLoader] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [reportName, setReportName] = useState(null);
	const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
	const [params, setParams] = useState({
		pageSize: Number(searchParams.get('pageSize')) || 10000,
		page: Number(searchParams.get('page')) || 1,
		orderBy: searchParams.get('orderBy') || '',
		sortBy: searchParams.get('sortBy') || '',
	});
	const [scheduleReportList, setScheduleReportList] = useState([]);

	const onRowClick = (id) => {
		const data = scheduleReportList.find((item) => item.id === id);
		setReportName(data['REPORT NAME']);
		setScheduledId(id);
		setIsOpen(true);
	};
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const handleExportExcel = async () => {
		try {
			setIsExportExcelLoader(true);
			const res = await exportExcelScheduledReport();
			if (res.success) {
				const a = document.createElement('a');
				a.href = res.data.signed_url;
				a.download = `scheduled_report_table.xlsx`;
				document.body.appendChild(a);
				a.click();
				a.remove();
				toast.success(res.message);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setIsExportExcelLoader(false);
		}
	};

	const scheduleReportColumns = [
		{
			field: 'REPORT NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			autoHeight: true,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'report_name', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REPORT NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.report_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'FREQUENCY',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'frequency', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								FREQUENCY
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.frequency]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return <div className="d-flex align-items-center">{params.data.frequency}</div>;
			},
		},
		{
			field: 'SCHEDULED BY',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'scheduled_by', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								SCHEDULED BY
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.schdeduled_by]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return <div className="d-flex align-items-center">{params.data.scheduled_by}</div>;
			},
		},
		{
			field: 'NEXT SCHEDULE ON',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 180,
			maxWidth: 180,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'next_schedule_on', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								NEXT SCHEDULE ON
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.next_schedule_on]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return <div className="d-flex align-items-center">{params.data.next_schedule_on}</div>;
			},
		},
		{
			field: 'EMAIL RECIPIENTS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'email_recipients', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								EMAIL RECIPIENTS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.email_recipients]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return <div className="d-flex align-items-center">{params.data.email_recipients}</div>;
			},
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 150,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'status', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return (
					<div className="d-flex align-items-center gap-2">
						<div
							className="fs-5 fw-semibold"
							style={{
								color:
									params.data.status === 'paused'
										? '#FEC53D'
										: params.data.status === 'inactive'
											? '#FF0000'
											: '#68C230',
							}}
						>
							{capitalizeWords(params.data.status)}
						</div>
					</div>
				);
			},
		},
		{
			field: 'FILE FORMAT',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 150,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				return (
					<div className="d-flex gap-3 align-items-center justify-content-center">
						<img
							src={
								params.data.file_format === 'pdf'
									? reportPdfIcon
									: params.data.file_format === 'csv'
										? csvIcon
										: xlsIcon
							}
							alt="icon"
						/>
						<div className="fs-4 fw-light">{params.data.file_format.toUpperCase()}</div>
					</div>
				);
			},
		},
	];

	const getScheduledReportList = async () => {
		try {
			setLoader(true);
			const { scheduled_reports } = await getScheduledReport(params);
			if (scheduled_reports.length > 0) {
				let data = mappedTableData(scheduled_reports);
				setScheduleReportList(data);
			} else {
				setScheduleReportList([]);
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				'REPORT NAME': capitalizeWords(ele.report_name.replaceAll('_', ' ')),
				frequency: capitalizeWords(ele.frequency),
				scheduled_by: ele.scheduled_by,
				next_schedule_on:
					ele.next_run_at !== null && ele.next_run_at !== '' ? formatAMPMDate(ele.next_run_at) : '',
				email_recipients:
					ele.primary_email !== null
						? ele.primary_email
						: ele.additional_recipients.length > 0
							? ele.additional_recipients[0]
							: '',
				status: ele.status,
				file_format: ele.file_format,
			};
		});
	}

	const setFilterFromUrl = () => {
		setSortDirection({
			[searchParams.get('orderBy')]: searchParams.get('sortBy') || '',
		});
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		url.set('page', params.page);
		url.set('pageSize', params.pageSize);
		url.set('orderBy', params.orderBy);
		url.set('sortBy', params.sortBy);

		setSearchParams(url);
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [params]);

	useEffect(() => {
		getScheduledReportList();
	}, [searchParams]);

	return (
		<div>
			<div>
				<div
					className="header-position-sticky"
					style={{ backgroundColor: '#FFF' }}
				>
					<ReportHeaderComponent
						title={'Scheduled Report'}
						subtitle={false}
						setIsCollapse={setIsCollapse}
						isCollapse={isCollapse}
						activeTab={activeTab}
						fromDate={''}
						toDate={''}
						buttons={[
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Export to Excel',
								disabled: isExportExcelLoader,
								loader: isExportExcelLoader,
								handler: () => handleExportExcel(),
							},
						]}
					/>
				</div>
				<div className="report-main-tabs-table">
					{loader ? (
						<PageLoader />
					) : (
						<div className="productTable-body">
							<Table
								row={scheduleReportList}
								coloum={scheduleReportColumns}
								className="productTable"
								onRowClick={onRowClick}
								style={{ height: 'calc(100vh - 143px)' }}
							/>
						</div>
					)}
				</div>
			</div>
			{isScheduleModalOpen && (
				<ScheduleReportModal
					isScheduleModelOpen={isScheduleModalOpen}
					setIsScheduleModelOpen={setIsScheduleModalOpen}
					activeTab={reportName}
					getList={() => {
						getScheduledReportList();
						setScheduledId(null);
					}}
					id={scheduledId}
				/>
			)}
			<ReportScheduledDrawer
				id={scheduledId}
				isOpen={isOpen}
				setIsScheduleModelOpen={setIsScheduleModalOpen}
				getList={() => getScheduledReportList()}
				onClose={() => setIsOpen(false)}
			/>
		</div>
	);
}
